import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Animated } from 'react-native';

import { View } from 'react-native';

import Label from './label';
import Text from '../text';

class Underline extends Component {
  constructor(props) {
    super(props);
    this.progress = new Animated.Value(this.props.error ? 1 : 0);
    this.state = {
      lineLength: 0,
    };
  }

  updateLineLength(lineLength, cb) {
    this.setState({ lineLength }, cb);
  }

  animationStretchUnderline(focused) {
    if (!(this.props.underlineEnabled && focused)) {
      return [];
    }

    this.progress.setValue(0);
    return [
      Animated.timing(this.progress, {
        toValue: 1,
        duration: this.props.animationDuration,
      }),
    ];
  }

  animationShrinkUnderline() {
    if (!this.props.underlineEnabled || this.props.error) {
      return [];
    }

    return [
      Animated.timing(this.progress, {
        toValue: 0,
        duration: this.props.animationDuration,
      }),
    ];
  }

  renderUnderline() {
    const {
      underlineActiveColor,
      underlineEnabled,
      underlineSize,
      error,
      errorColor,
    } = this.props;

    const left = this.progress.interpolate({
      inputRange: [0, 1],
      outputRange: [this.state.lineLength / 2, 0],
    });

    const width = this.progress.interpolate({
      inputRange: [0, 1],
      outputRange: [0, this.state.lineLength],
    });

    return underlineEnabled && (
      <Animated.View
        style={{
          position: 'absolute',
          backgroundColor: error ? errorColor : underlineActiveColor,
          height: underlineSize ,
          left,
          width,
        }}
      />);
  }

  renderError() {
    const { error, errorText, errorSize, errorColor } = this.props;
    if (!error || !errorText) {
      return null;
    }

    return (
      <Text
        size={errorSize}
        style={{
          color: errorColor,
          marginTop: 0,
        }}
      >
        {errorText}
      </Text>
    );
  }

  render() {
    return (
      <View pointerEvents="none">
        <View
          style={{
            height: this.props.underlineSize,
          }}
        >
          <View
            style={{
              position: 'absolute',
              backgroundColor: this.props.underlineColor,
              height: this.props.underlineSize,
              width: this.state.lineLength,
            }}
          />
          {this.renderUnderline()}
        </View>
        {this.renderError()}
      </View>
    );
  }
}

Underline.propTypes = {
  underlineEnabled: PropTypes.bool,
  underlineColor: PropTypes.string,
  underlineActiveColor: PropTypes.string,
  underlineSize: PropTypes.number,
  animationDuration: PropTypes.number,
  errorColor: PropTypes.string,
  errorSize: Text.propTypes.size,
  error: PropTypes.bool,
  errorText: PropTypes.string,
};

Underline.defaultProps = {
  underlineEnabled: true,
  animationDuration: Label.defaultProps.animationDuration,
  underlineSize: 1,
  errorSize: 'small',
};

export default Underline;
